@import './cms-badge.scss';

.scratch {
  background-color: var(--cms-badge-background-color);
  -webkit-mask-size: cover;
  mask-size: cover;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  width: 3px;
}

.scratch-right {
  -webkit-mask-position: right;
  mask-position: right;
}

.close-button:focus-visible,
.badge-link:focus-visible {
  outline: none;
  box-shadow: 0 0 0 var(--cms-spacing-025) var(--cms-badge-focus-color);
}